import { setSinglePageRequestPrefillPayload } from '@/plugins/app/_config/modules/single-page-request-prefill'
import type { TokenHandshakeHandler } from './types'

export const prefillRequestHandler: TokenHandshakeHandler = async (
	params,
	{ router }
) => {
	if (!params || typeof params !== 'object') {
		return {
			error: {
				code: -32602,
				message: 'Invalid params: prefill payload is required'
			}
		}
	}

	setSinglePageRequestPrefillPayload(params)

	void router.push({
		name: 'Single Page Request'
	})

	return {
		result: 1
	}
}
